import CallToAction from "components/CallToAction"
import Modal from "components/Modal"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import track from "utilities/track"
import useModal from "utilities/useModal"
import richText from "utilities/richText"

export default function CalendlyEmbed({ blok }) {
  const [height, setHeight] = useState(`unset`)
  const router = useRouter()
  const { ...modalProps } = useModal("#success")

  // listen for Calendly embed notifications
  useEffect(() => {
    // copied from https://developer.calendly.com/api-docs/ZG9jOjI3ODM2MTAz-notifying-the-parent-window
    // similar version at https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview?tab=advanced#6
    function isCalendlyEvent(e) {
      return e.data.event && e.data.event.indexOf("calendly.") === 0
    }

    async function calendlyEventListener(e) {
      if (isCalendlyEvent(e)) {
        /**
         * Hacky way to scope enrollment tracking in case they decide to reuse this component
         * for other purposes elsewhere (while preserving functionality) without being required
         * to reach out to us about it first.
         */
        const { pathname } = window.location
        const isEnrollmentPage = pathname.startsWith("/locations") && pathname.endsWith("enroll")

        if (isEnrollmentPage) {
          // hacky way to get location info
          const [_0, _1, state, region, locationName] = pathname.split("/")

          switch (e.data.event) {
            case "calendly.event_type_viewed":
              track({
                event: "enrollment_form_viewed",
                state,
                region,
                locationName,
              })
              break

            case "calendly.date_and_time_selected":
              /**
               * Once a user selects a date and time, the iframe height needs to grow to accomodate
               * the length of the submission form. These numbers are manually tuned to that height.
               *
               * 🤮 magic numbers ¯\_(ツ)_/¯ Sometimes they're necessary (boo, 3rd-party vendors)!
               */
              setHeight(`2800px`)

              track({
                event: "enrollment_date_and_time_selected",
                state,
                region,
                locationName,
              })
              break
            // throw a flippin' party (╯°□°）╯︵ ┻━┻
            case "calendly.event_scheduled":
              const { invitee } = e.data.payload

              try {
                const submissionResponse = await fetch("/.netlify/functions/getCalendlySubmission", {
                  method: "POST",
                  body: JSON.stringify(invitee),
                })

                const formData = await submissionResponse.json()

                // e.g. "https://app.smartsheet.com/sheets/7fj9GffG4cQX59mQvQFj46W2hW3vmqv7vmqcVHC1?view=grid"
                // => "/sheets/7fj9GffG4cQX59mQvQFj46W2hW3vmqv7vmqcVHC1"
                // => "7fj9GffG4cQX59mQvQFj46W2hW3vmqv7vmqcVHC1"
                const sheetId = new URL(blok.smartsheet_url).pathname.split("/sheets/")[1]

                // insert data into smartsheet
                navigator.sendBeacon("/.netlify/functions/insertSmartsheetRow", JSON.stringify({ sheetId, formData }))

                // We can pass any non-PII data to the dataLayer here along with the event to analytics
                track({
                  event: "enrollment_scheduled",
                  state,
                  region,
                  locationName,
                  driveTime: formData["How many minutes does client drive to Dogtown?"],
                  plannedServices: formData["How do you plan to use our business?"],
                  proximityToLocation: formData["Does customer live or work near Dogtown?"],
                })

                router.push(`${router.asPath}#success`)

                setTimeout(() => {
                  window.open(blok.petexec_url, "_blank")
                }, 3000)
              } catch (error) {
                console.error(error)
              }
              break
            default:
              console.info(e.data)
              break
          }
        }

        // catch all events and track by default
        track({ event: e.data.event })
      }
    }

    window.addEventListener("message", calendlyEventListener)

    return () => {
      window.removeEventListener("message", calendlyEventListener)
    }
  }, [blok.smartsheet_url, router, blok.petexec_url])

  return (
    <section>
      <iframe
        style={{ height, minWidth: "320px" }}
        className="px-8 calendly-embed"
        src={`${blok.calendly_embed_url}?hide_landing_page_details=1&hide_gdpr_banner=1&embed_type=inline&primary_color=137170&text_color=404040&embed_domain=dogtowncentral.com`}
      />
      <Modal {...modalProps}>
        <h2 className="mb-2">Enrollment Evaluation Scheduled</h2>
        <div>{richText(blok.redirect_message)}</div>
        <div className="block mx-auto text-center mt-4">
          <CallToAction target="_blank" href={`${blok.petexec_url}?`}>
            Open in a New Window
          </CallToAction>
        </div>
      </Modal>
    </section>
  )
}
